module.exports = __webpack_public_path__ + "img/promotion-1.91ab8cbd.png";